﻿import { get } from 'svelte/store';
import { _ } from 'svelte-i18n';
import {
    MEASUREMENT_FIELD_CURRENT_DURATION, MEASUREMENT_FIELD_CURRENT_SPEED,
    MEASUREMENT_FIELD_DELAY_DURATION, MEASUREMENT_FIELD_DELAY_FACTOR,
    MEASUREMENT_FIELD_DISTANCE,
    MEASUREMENT_FIELD_END_GATE_NAME, MEASUREMENT_FIELD_OPTIMAL_DURATION, MEASUREMENT_FIELD_OPTIMAL_SPEED,
    MEASUREMENT_FIELD_ROUTE_ID,
    MEASUREMENT_FIELD_ROUTE_NAME, MEASUREMENT_FIELD_SPEED_DIFFERENCE, MEASUREMENT_FIELD_START_GATE_NAME,
    MEASUREMENT_FIELD_TIMESTAMP, MEASUREMENT_FIELD_TYPICAL_DURATION, MEASUREMENT_FIELD_TYPICAL_SPEED
} from "../constants/measurement-table-constants";

export function translate(key: string, values?: Record<string, unknown>): string {
    return get(_)(key);
}

export function getMeasurementFieldLabel(measurementField: string): string {
    switch (measurementField) {
        case MEASUREMENT_FIELD_ROUTE_ID:
            return translate('measurements.labels.ROUTE_ID');
        case MEASUREMENT_FIELD_TIMESTAMP:
            return translate('measurements.labels.TIMESTAMP');
        case MEASUREMENT_FIELD_DISTANCE:
            return translate('measurements.labels.DISTANCE');
            
        case MEASUREMENT_FIELD_OPTIMAL_DURATION:
            return translate('measurements.labels.OPTIMAL_DURATION');
        case MEASUREMENT_FIELD_OPTIMAL_SPEED:
            return translate('measurements.labels.OPTIMAL_SPEED');
            
        case MEASUREMENT_FIELD_TYPICAL_DURATION:
            return translate('measurements.labels.TYPICAL_DURATION');
        case MEASUREMENT_FIELD_TYPICAL_SPEED:
            return translate('measurements.labels.TYPICAL_SPEED');
            
        case MEASUREMENT_FIELD_CURRENT_DURATION:
            return translate('measurements.labels.CURRENT_DURATION');
        case MEASUREMENT_FIELD_CURRENT_SPEED:
            return translate('measurements.labels.CURRENT_SPEED');
            
        case MEASUREMENT_FIELD_DELAY_FACTOR:
            return translate('measurements.labels.DELAY_FACTOR');
        case MEASUREMENT_FIELD_DELAY_DURATION:
            return translate('measurements.labels.DELAY_DURATION');
        case MEASUREMENT_FIELD_SPEED_DIFFERENCE:
            return translate('measurements.labels.SPEED_DIFFERENCE');

        case MEASUREMENT_FIELD_START_GATE_NAME:
            return translate('measurements.labels.START_GATE_NAME');
        case MEASUREMENT_FIELD_END_GATE_NAME:
            return translate('measurements.labels.END_GATE_NAME');
        case MEASUREMENT_FIELD_ROUTE_NAME:
            return translate('measurements.labels.ROUTE_NAME');
    }
    
    console.warn(`No label for unknown measurement field: ${measurementField}`);
    return ''
}

export function getMeasurementFieldDescription(measurementField: string): string {
    switch (measurementField) {
        case MEASUREMENT_FIELD_OPTIMAL_DURATION:
            return translate('measurements.descriptions.OPTIMAL_DURATION');
        case MEASUREMENT_FIELD_OPTIMAL_SPEED:
            return translate('measurements.descriptions.OPTIMAL_SPEED');
            
        case MEASUREMENT_FIELD_TYPICAL_DURATION:
            return translate('measurements.descriptions.TYPICAL_DURATION');
        case MEASUREMENT_FIELD_TYPICAL_SPEED:
            return translate('measurements.descriptions.TYPICAL_SPEED');
            
        case MEASUREMENT_FIELD_CURRENT_DURATION:
            return translate('measurements.descriptions.CURRENT_DURATION');
        case MEASUREMENT_FIELD_CURRENT_SPEED:
            return translate('measurements.descriptions.CURRENT_SPEED');
            
        case MEASUREMENT_FIELD_DELAY_FACTOR:
            return translate('measurements.descriptions.DELAY_FACTOR');
        case MEASUREMENT_FIELD_DELAY_DURATION:
            return translate('measurements.descriptions.DELAY_DURATION');
        case MEASUREMENT_FIELD_SPEED_DIFFERENCE:
            return translate('measurements.descriptions.SPEED_DIFFERENCE');
    }

    console.warn(`No description for unknown measurement field: ${measurementField}`);
    return ''
}

export function getMeasurementFieldUnit(measurementField: string): string {
    switch (measurementField) {
        case MEASUREMENT_FIELD_OPTIMAL_DURATION:
        case MEASUREMENT_FIELD_TYPICAL_DURATION:
        case MEASUREMENT_FIELD_CURRENT_DURATION:
        case MEASUREMENT_FIELD_DELAY_DURATION:
            return translate('measurements.SECONDS');
            
        case MEASUREMENT_FIELD_OPTIMAL_SPEED:
        case MEASUREMENT_FIELD_TYPICAL_SPEED:
        case MEASUREMENT_FIELD_CURRENT_SPEED:
        case MEASUREMENT_FIELD_SPEED_DIFFERENCE:
            return translate('measurements.KILOMETERS_PER_HOUR_SHORT');

        case MEASUREMENT_FIELD_DELAY_FACTOR:
            return translate('measurements.PERCENT');
    }

    console.warn(`No description for unknown measurement field: ${measurementField}`);
    return ''
}